module.exports = __webpack_public_path__ + "a28c595635467f641627b0a3a82a9b46.svg";